import React from "react"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

import Header from "./header"
import Footer from "./footer"
import "./layout.css"

export const PageContext = React.createContext(undefined);

const BreadcrumbWrapper = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;

  return <Breadcrumb crumbs={crumbs} />
}

type LayoutProps = {
  children: React.ReactNode,
  pageContext?: any,
};

export default ({ children, pageContext }: LayoutProps) => {
  return (
    <>
      <Header />
      {!pageContext ? null : <BreadcrumbWrapper pageContext={pageContext} />}
      <main>{children}</main>
      <Footer />
    </>
  )
}
